/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DeleteProjectPenaltyCommand } from '../../models/delete-project-penalty-command';
import { DeleteProjectPenaltyCommandResult } from '../../models/delete-project-penalty-command-result';

export interface ApiProjectPenaltiesDeleteProjectPenaltyDelete$Plain$Params {
      body?: DeleteProjectPenaltyCommand
}

export function apiProjectPenaltiesDeleteProjectPenaltyDelete$Plain(http: HttpClient, rootUrl: string, params?: ApiProjectPenaltiesDeleteProjectPenaltyDelete$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<DeleteProjectPenaltyCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiProjectPenaltiesDeleteProjectPenaltyDelete$Plain.PATH, 'delete');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DeleteProjectPenaltyCommandResult>;
    })
  );
}

apiProjectPenaltiesDeleteProjectPenaltyDelete$Plain.PATH = '/api/ProjectPenalties/DeleteProjectPenalty';
